import * as API from 'common/constant/routes'
import { getJson, getText, postJson } from 'helper/http'

export const getVisNetworkData = (bucketKey) => getText(API.GET_VISNETWORK_DATA, {}, { bucketKey })
export const getLastSession = (userId) => getJson(API.GET_LAST_SESSION_URL, {}, { userId })
export const saveLastSession = (userId, url) => postJson(API.SAVE_LAST_SESSION_URL, {}, { userId, url })

export const getContactsById = (id) => postJson(API.GET_CONTACTS_BY_ID, {}, { id })
export const getContactsByValue = (contact) => postJson(API.GET_CONTACTS_BY_VALUE, {}, { contact })
export const getSearchByValue = (contact) => postJson(API.GET_SEARCH_BY_VALUE, {}, { contact })
export const getCustomerById = (id) => postJson(API.GET_CUSTOMER_BY_ID, {}, { id })
export const getCustomerByName = (customerName) => postJson(API.GET_CUSTOMER_BY_NAME, {}, { customerName })
export const getRetailers = () => getJson(API.GET_RETAILERS, {}, {})
export const getRefundsById = (id) => postJson(API.GET_RETURNS_BY_ID, {}, { id })
export const getNetworkState = (data) => postJson(API.GET_NETWORK_STATE, {}, { data })
export const getExplorerBuilder = (data) => postJson(API.GET_EXPLORER_BUILDER, {}, { data })
export const getCustomerEdge = (id, contact) => postJson(API.GET_CUSTOMER_EDGE, {}, { id, contact })
export const getCustomerByValue = (customerId) => postJson(API.GET_CUSTOMER_BY_VALUE, {}, { customerId })
